/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Peer_Support_AriaInputs */

const en_service_peer_support_aria = /** @type {(inputs: Service_Peer_Support_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Peer Community Page`)
};

const fr_service_peer_support_aria = /** @type {(inputs: Service_Peer_Support_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers la page de la communauté de pairs`)
};

/**
* | output |
* | --- |
* | "Link to Peer Community Page" |
*
* @param {Service_Peer_Support_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_peer_support_aria = /** @type {((inputs?: Service_Peer_Support_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Peer_Support_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_peer_support_aria(inputs)
	return fr_service_peer_support_aria(inputs)
});